import flatten from "lodash/flatten";
import { WSInfiniteQueryConfig } from "@ws-react-query";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import { ApiQueryListWorkLogs, listWorkLogs } from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSInfiniteQuery } from "../../helpers";

const PAGE_SIZE = 20;

export const QUERY_WORK_LOGS = "QUERY_WORK_LOGS";

export const useQueryWorkLogs = (
  requestQuery?: ApiQueryListWorkLogs,
  config?: WSInfiniteQueryConfig<IWorkLog[], WSServiceError>
) => {
  const query = useWSInfiniteQuery<IWorkLog[], WSServiceError>(
    [QUERY_WORK_LOGS, requestQuery],
    ({ pageParam = 1 }) => {
      return listWorkLogs({
        ...requestQuery,
        page: {
          size: requestQuery?.page?.size || PAGE_SIZE,
          number: pageParam
        }
      });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < PAGE_SIZE) {
          return undefined;
        } else {
          return allPages.length + 1;
        }
      },
      ...config
    }
  );

  return {
    ...query,
    data: query.data ? flatten(query.data.pages) : undefined
  };
};
